var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 512h-482c-8.284 0-15-6.716-15-15v-482c0-8.284 6.716-15 15-15h482c8.284 0 15 6.716 15 15v482c0 8.284-6.716 15-15 15z",
    fill: "#08475e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 497v-482c0-8.284-6.716-15-15-15h-241v512h241c8.284 0 15-6.716 15-15z",
    fill: "#05303d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.732 200.835h-180.688l46.694-46.694c5.858-5.858 5.858-15.355 0-21.213l-48.2-48.2c-5.858-5.858-15.355-5.858-21.213 0l-160.665 160.665c-5.858 5.858-5.858 15.355 0 21.213l160.667 160.667c5.858 5.858 15.355 5.858 21.213 0l48.199-48.198c5.858-5.858 5.858-15.355 0-21.213l-46.694-46.694 180.688.001c8.284 0 15-6.716 15-15v-80.334c-.001-8.285-6.717-15.001-15.001-15z",
    fill: "#f4f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e7dfdd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298.738 357.861-42.738-42.738v106.69l42.738-42.739c5.858-5.857 5.858-15.355 0-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.738 132.928-42.738-42.739v106.69l42.738-42.739c5.858-5.857 5.858-15.354 0-21.212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.732 200.835h-176.732v110.332l176.732.001c8.284 0 15-6.716 15-15v-80.334c0-8.284-6.716-15-15-14.999z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.bb8212417c544a2dc6b65fb6296d17fc.svg";
export { ForwardRef as ReactComponent };